module.exports = __webpack_public_path__ + "static/media/link.2663ac0d.svg";